module.exports = __webpack_public_path__ + "media/images/lb/927-b1d618faffec29d0f0a66454b5079928.svg";